module.exports = __webpack_public_path__ + "img/65_6.94235bf0.png";